import React, { useEffect, useRef } from 'react';
import { Box, Typography, Grid, Button, Divider } from '@mui/material';

export default function Contact() {
  const mapRef = useRef(null);

  useEffect(() => {
    // Load Google Maps script
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAOH_nwaLAsF4n_DbWebTYGdN-FbJmQWjI`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    script.onload = () => {
      const location = { lat: 20.6107, lng: 72.9273 };
      const map = new window.google.maps.Map(mapRef.current, {
        center: location,
        zoom: 15,
        styles: [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
          }
        ]
      });

      new window.google.maps.Marker({
        position: location,
        map,
        title: 'Aqeus Healthcare',
        animation: window.google.maps.Animation.DROP
      });
    };

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <Box sx={{ p: { xs: 1, sm: 2 }, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h3" gutterBottom>Contact Us</Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={4} direction={{ xs: 'column', md: 'row' }}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>Contact Information</Typography>
          <Typography>Email: aqeushealthcare@gmail.com</Typography>
          <Typography>Phone: +91-9974301565</Typography>
          <Typography>Address: 161 VANKAL DARU FALIYA, near jalaram sawe mill Valsad</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>Send us a message</Typography>
          <form>
            <input type="text" placeholder="Name" style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', marginBottom: 16 }} required />
            <input type="email" placeholder="Email" style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', marginBottom: 16 }} required />
            <input type="tel" placeholder="Phone no" style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', marginBottom: 16 }} required />
            <textarea placeholder="Message" rows={4} style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', marginBottom: 16 }} required />
            <Button type="submit" variant="contained" color="primary" fullWidth>Submit</Button>
          </form>
        </Grid>
      </Grid>
      <Divider sx={{ my: 4 }} />
      
      {/* Google Map Section */}
      <Box sx={{ width: '100%', height: { xs: 300, sm: 400 }, borderRadius: 2, overflow: 'hidden', boxShadow: 3 }}>
        <div ref={mapRef} style={{ width: '100%', height: '100%' }} />
      </Box>
    </Box>
  );
}